import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { withLocalize } from "react-localize-redux";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, ActionIcon} from '@mantine/core';
import { IconSquareRoundedX } from '@tabler/icons';
import _ from 'lodash';
import moment from 'moment'

import ContainerTranslation from "../partials/ContainerTranslation";

import { fetchProject, 
          updateFieldProject, 
          addFieldProject, 
          removeFieldProject, 
          getAutocompleteList, 
          validate,
          submit,
          draft,
          reject,
          resetError } from '../../actions/project';

import {exampleContext,exampleObjectives,exampleActivity} from '../../assets/placeholder';
import { InputText } from '../input/InputText.tsx';
import { InputDate } from '../input/InputDate';
import { TextAreaLabeled,TextAreaLabeledStatic } from '../input/TextAreaLabeled.tsx';
import { SelectLabeled } from '../input/SelectLabeled.tsx';
import SelectAddField from '../input/SelectAddField';
import { CreatableSelectLabeled } from '../input/CreatableSelectLabeled.tsx';
import ExtractorPowerPoint from '../partials/ExportPowerPoint';
import AddButton from '../partials/AddButton';
import { SliderCheckboxLabeled } from '../input/Checkbox';

var updateTimeout = {}

class FormContainer extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isPopupOpen: false,
      isValidatePopupOpen: false,
      isRejectPopupOpen: false,
      isSubmitPopupOpen: false,
    }
    this.props.fetchProject(this.props.match.params.id);
      this.props.getAutocompleteList(this.props.match.params.id);
    this.rejectReason = React.createRef();
  } 


  togglePopup() {
    if (this.state.isPopupOpen) {
      this.setState({ isPopupOpen: false })
    }
    else {
      this.setState({ isPopupOpen: true })
    }
  }

    toggleValidatePopup() {
        this.setState({ isRejectPopupOpen: false, isSubmitPopupOpen: false, isValidatePopupOpen: !this.state.isValidatePopupOpen });
    }

    toggleRejectPopup() {
        this.setState({ isRejectPopupOpen: !this.state.isRejectPopupOpen, isSubmitPopupOpen: false, isValidatePopupOpen: false });
    }

    toggleSubmitPopup() {
        this.setState({ isRejectPopupOpen: false, isSubmitPopupOpen: !this.state.isSubmitPopupOpen, isValidatePopupOpen: false });
    }

  scrollTop() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
      if (Object.keys(prevProps.project).length !== 0 && Object.keys(this.props.project).length && prevProps.project.validationInformation.validationStatus !== this.props.project.validationInformation.validationStatus) {
          this.setState({ isRejectPopupOpen: false, isSubmitPopupOpen: false, isValidatePopupOpen: false });
      }

  }


  handleDocumentValidation(obj){
    this.props.validate(this.props.match.params.id);
  }

  handleDocumentSubmit(obj){
    this.props.submit(this.props.match.params.id);
  }

  handleDocumentDraft(obj){
    this.props.draft(this.props.match.params.id);
  }

  handleDocumentReject(obj){
    this.props.reject(this.props.match.params.id,this.rejectReason.current);
  }


  handleInputChange(obj, isValid, withTimeout) {
    var _this = this
    if (withTimeout) {
      clearTimeout(updateTimeout[obj.name]);
      updateTimeout[obj.name] = setTimeout(function () {
        delete updateTimeout[obj.name]
        _this.props.updateFieldProject(obj, _this.props.match.params.id);
      }, 1000)
    } else {
      _this.props.updateFieldProject(obj, _this.props.match.params.id);
    }
  }

  handleDateChangeFactory(name,parent,index){
    const _this = this
    function handleChangeDate(date){

      if (date === null || date === undefined){
        return _this.props.updateFieldProject({name:name,parent:parent,index:index,value:null}, _this.props.match.params.id);
      }
      const parseddate = new Date(date) 
      const formattedDate = parseddate !== "Invalid Date" ? moment(parseddate).format('DD/MM/YYYY') : null

      return _this.props.updateFieldProject({name:name,parent:parent,index:index,value:formattedDate}, _this.props.match.params.id);
    }
    return handleChangeDate
  }

  string2Date(date){
    return date ? new Date(Date.parse(moment(date, 'DD/MM/YYYY').toISOString())) : null
  }


  handleBlurFactory(parent,index){
    const handleBlur = (e) => {
      this.props.updateFieldProject({name : e.target.name, value : e.target.value, parent : parent,  index : index}, this.props.match.params.id);
    }
    return handleBlur
  }


  handleBlur = (obj) => {
    let _this = this
    _this.props.updateFieldProject(obj, _this.props.match.params.id);
  }

  handleClientChange(obj, isValid, withTimeout) {
    var _this = this
    if (withTimeout) {
      clearTimeout(updateTimeout[obj.name]);
      updateTimeout[obj.name] = setTimeout(function () {
        delete updateTimeout[obj.name]
        
        _this.props.updateFieldProject(obj, _this.props.match.params.id);
      }, 1000)
    } else {
      _this.props.updateFieldProject(obj, _this.props.match.params.id);
    }

  }


  /// will replace handleInputChange once I refactored all input ...
  handleInputChangeFactoryNew(parent,name,index) {

    const handleInputChange = (e) => {
      this.props.updateFieldProject({  name : name, 
                                          value : Array.isArray(e) ? e.map((ele)=>ele.value)  : e.value, 
                                          parent : parent,  
                                          index : index
                                        }, this.props.match.params.id);
    }

    return handleInputChange

  }

    handleFieldsOnChangeFactory(parent, index) {

        function handleFieldOnChangeFactory(subfield) {
            const handleFieldOnChange = (e) => {
                this.props.updateFieldProject({
                    name: subfield,
                    value: Array.isArray(e) ? e.map((ele) => ele.value) : e.value,
                    parent: parent,
                    index: index
                }, this.props.match.params.id);
            }
            return handleFieldOnChange.bind(this)
        }

        return handleFieldOnChangeFactory.bind(this)

    }


    handleFieldOnChangeFactory(parent,subfield) {
        const handleFieldOnChange = (e) => {
            this.props.updateFieldProject({
                name: subfield,
                value: Array.isArray(e) ? e.map((ele) => ele.value) : e.value,
                parent: parent
            }, this.props.match.params.id);
        }
        return handleFieldOnChange.bind(this)
    }


  handleClickSwitchFactory(parent,subfield){
    const handleClickSwitch = (e) => {
      this.props.updateFieldProject({
          name: subfield,
          value: this.props.project.content.information[subfield] === "true" ? "false" : "true",
          parent: parent
      }, this.props.match.params.id);
  }
  return handleClickSwitch.bind(this)
  }

  handleEnvironnementChange(obj, isValid, withTimeout) {
    var _this = this
    var value = this.props.content['environnement']['environnement-domain']
    var foundDomain = _.find(value, function (v) {
      return v === obj.value
    })

    if (foundDomain) {
      _.remove(value, function (v) {
        return v === obj.value
      })
    } else {
      value.push(obj.value)
    }
    var objToReturn = {
      index: undefined,
      name: "environnement-domain",
      parent: "environnement",
      value: value
    }
    _this.props.updateFieldProject(objToReturn, _this.props.match.params.id);
  }

  handleContextChange(obj, isValid, withTimeout) {
    var _this = this
    var value = this.props.content['environnement']['environnement-context']
    var foundContext = _.find(value, function (v) {
      return v === obj.value
    })

    if (foundContext) {
      _.remove(value, function (v) {
        return v === obj.value
      })
    } else {
      value.push(obj.value)
    }
    var objToReturn = {
      index: undefined,
      name: "environnement-context",
      parent: "environnement",
      value: value
    }
    _this.props.updateFieldProject(objToReturn, _this.props.match.params.id);
  }

  duplicate(obj) {
    let objToReturn = {}
    if(this.props.content[obj] && this.props.content[obj][0]){
      _.forEach(this.props.content[obj][0], function (o, key) {
        objToReturn[key] = ''
      })
    }
    this.props.addFieldProject(objToReturn, obj, this.props.match.params.id);
  }

  remove(obj, i) {
    this.props.removeFieldProject(i, obj, this.props.match.params.id);
  }

  renderCreateOperationalSkillsInput() {
    var options = []
    var arr = []
    var _this = this
 

    _.each(_this.props.list.operational['intervention-mission'], function (missionArray, type) {
      missionArray.map(mission => {
        var obj = {};

        const typeLabel = _this.props.translate(['intervention-type'] + "." + type);
        const missionLabel = _this.props.translate(["intervention-mission"] + "." + [type] + "." + [mission]);

        obj['intervention-mission'] = mission;
        obj['intervention-type'] = _this.props.list.operational['intervention-type'].find(item => item === type);
        obj['label'] = `${missionLabel} > ${typeLabel} `;

        if (missionLabel && typeLabel) {
          return options.push(obj);
        };
        return null;
      });
    });

    _.each(_this.props.list.operational['intervention-application'], function (appArray, key) {
      appArray.map(app => {
        var obj = {};
        var type;
        _.each(_this.props.list.operational['intervention-mission'], function (missionArray, missionkey) {
          if (missionArray.filter(mission => mission === key).length !== 0) {
            return type = missionkey;
          }
        })
        arr.push(app)
        obj['intervention-application'] = app;
        obj['intervention-mission'] = key;
        obj['intervention-experience'] = "";
        obj['intervention-type'] = type;

        const typeLabel = _this.props.translate(['intervention-type'] + "." + type);
        const missionLabel = _this.props.translate(["intervention-mission"] + "." + [type] + "." + [key]);
        const appLabel = _this.props.translate(['intervention-application'] + "." + [key] + "." + [app]);
        obj['label'] = `${appLabel} > ${missionLabel} > ${typeLabel} `;

        if (missionLabel && typeLabel) {
          return options.push(obj);
        };
        return null;
      });
    });
    return <SelectAddField
      type={"project"}
      noLabel={false}
      isRequired={true}
      placeholder={<ContainerTranslation id={['content'] + "." + ['placeholder'] + "." + ['search-skill']} />}
      id={_this.props.match.params.id}
      section={'content.intervention-level'}
      parent={'intervention-level'}
      options={options} />;

  }

  renderOperationalSkills(interventionLevel = [{}]) {
      let contents = [];
      const _this = this;

      _.each(interventionLevel, function (content, i) {

          const keySuffix = i + Date.now()

          let interventionType = {
              value: content['intervention-type'],
              label: _this.props.translate(`intervention-type.${content['intervention-type']}`)
          };
          let interventionTypeOptions = _this.props.list.operational['intervention-type'].map(
              (x) => { return { value: x, label: _this.props.translate(`intervention-type.${x}`) } }
          );

          const handleFieldOnChangeFactory = _this.handleFieldsOnChangeFactory('intervention-level', i)

          let interventionMission = { value: "", label: "" };
          let interventionMissionOptions = [];
          let interventionApplication = { value: "", label: "" };
          let interventionApplicationOptions = [];
          let level4 = { value: "", label: "" };
          let level4Options = [];


          if (_this.props.list.operational['intervention-mission'][content['intervention-type']]) {
              interventionMission = {
                  value: content['intervention-mission'],
                  label: _this.props.translate(`intervention-mission.${content['intervention-type']}.${content['intervention-mission']}`)
              };
              interventionMissionOptions = _this.props.list.operational['intervention-mission'][content['intervention-type']].map(
                  (x) => { return { value: x, label: _this.props.translate(`intervention-mission.${content['intervention-type']}.${x}`) } }
              );
          }

          if (_this.props.list.operational['intervention-application'][content['intervention-mission']]) {
              interventionApplication = {
                  value: content['intervention-application'],
                  label: _this.props.translate(`intervention-application.${content['intervention-mission']}.${content['intervention-application']}`)
              };
              interventionApplicationOptions = _this.props.list.operational['intervention-application'][content['intervention-mission']].map(
                  (x) => { return { value: x, label: _this.props.translate(`intervention-application.${content['intervention-mission']}.${x}`) } }
              );
          }

          if (_this.props.list.operational['intervention-level-4'][content['intervention-application']]) {
              level4 = {
                  value: content['level-4'],
                  label: content['level-4']
              };
              level4Options = _this.props.list.operational['intervention-level-4'][content['intervention-application']].map(
                  (x) => { return { value: x, label: x } }
              );
          }


      if (i > 0) {
          contents.push(<div key={'separator-' + keySuffix} className="separator">
              <div className="delete-part" onClick={_this.remove.bind(_this, 'intervention-level', i)} key={'intervention-level-remove-' + keySuffix} id={'intervention-level-remove-' + keySuffix}>
                  <i className="fas fa-trash"></i>
              </div>
          </div>)
      }
        contents.push(<div key={'intervention-level1-' + keySuffix} className={"inline"} style={{ width: 'calc(24% - 9px)' }}>
            <SelectLabeled
                label={{ title: _this.props.translate(`intervention-type.title`) }}
                value={interventionType}
                onChange={handleFieldOnChangeFactory('intervention-type')}
                options={interventionTypeOptions}
            />
      </div>)
          if (interventionMissionOptions && interventionMissionOptions.length > 0) {
          contents.push(<div key={'intervention-level2-' + keySuffix} className={"inline"} style={{ width: 'calc(24% - 9px)', marginLeft: '12px' }}>
              <SelectLabeled
                  label={{ title: _this.props.translate(`intervention-mission.${content['intervention-type']}`) }}
                  value={interventionMission}
                  onChange={handleFieldOnChangeFactory('intervention-mission')}
                  options={interventionMissionOptions}
              />
        </div>)
      }
          if (interventionApplicationOptions && interventionApplicationOptions.length > 0) {
          contents.push(<div key={'intervention-level3-' + keySuffix} className={"inline"} style={{ width: 'calc(24% - 9px)', marginLeft: '12px' }}>
              <SelectLabeled
                  label={{ title: _this.props.translate(`intervention-application.${content['intervention-mission']}`) }}
                  value={interventionApplication}
                  onChange={handleFieldOnChangeFactory('intervention-application')}
                  options={interventionApplicationOptions}
              />
        </div>)
      }  
          if (level4Options && level4Options.length > 0) {
          contents.push(<div className={"inline"} style={{ width: 'calc(24% - 9px)', marginLeft: '12px' }}>
              <SelectLabeled
                  label={{ title: _this.props.translate(`content.intervention-level.level-4.title`) }}
                  value={level4}
                  onChange={handleFieldOnChangeFactory('level-4')}
                  options={level4Options}
              />
        </div>)
    }
    })
    contents.push(<div key={'intervention-level-duplicate'} className="duplicate" onClick={_this.duplicate.bind(_this, 'intervention-level')}>
      <AddButton />
    </div>)

    return (
      <div className={"formulaire wide"}>
        <div className={"formulaire-field text"}>
          {contents}
        </div>
      </div>
    )
    
  }

  renderCreateEngineeringSkillsInput() {
    var options = []
    var _this = this


    _.each(_this.props.list.engineering['engineering-specialization'], function (specializationArray, key) {
      specializationArray.map(specializationName => {
        var obj = {};
        obj['engineering-skill'] = key;
        obj['engineering-specialization'] = specializationName;
        obj['engineering-experience'] = "";
        const skillLabel = _this.props.translate(['engineering-skill'] + "." + key);
        const specializationLabel = _this.props.translate(['engineering-specialization'] + "." + [key] + "." + [specializationName]);
        obj['label'] = `${specializationLabel} > ${skillLabel}`;
        // obj['label'] = `${specializationName} > ${key}`;
        return options.push(obj);
      });
    });

    return <SelectAddField
      type={"project"}
      noLabel={false}
      isRequired={true}
      id={this.props.match.params.id}
      placeholder={<ContainerTranslation id={['content'] + "." + ['placeholder'] + "." + ['search-skill']} />}
      section={'content.engineering'}
      parent={'engineering'}
      options={options} />;

  }

  renderEngineeringSkills(engineering = [{}]) {
    let contents = []
    const _this = this;



    _.each(engineering, function (content, i) {
        const keySuffix = i + Date.now()

        const handleFieldOnChangeFactory = _this.handleFieldsOnChangeFactory('engineering', i);

        let engineeringSkill = {
            value: content['engineering-skill'],
            label: _this.props.translate(`engineering-skill.${content['engineering-skill']}`)
        };
        let engineeringSkillOptions = _this.props.list.engineering['engineering-skill'].map(
            (x) => { return { value: x, label: _this.props.translate(`engineering-skill.${x}`) } }
        );

        let engineeringSpecialization = { value: "", label: "" };
        let engineeringSpecializationOptions = [];

        if (_this.props.list.engineering['engineering-specialization'][content['engineering-skill']]) {
            engineeringSpecialization = {
                value: content['engineering-specialization'],
                label: _this.props.translate(`engineering-specialization.${content['engineering-skill']}.${content['engineering-specialization']}`)
            };
            engineeringSpecializationOptions = _this.props.list.engineering['engineering-specialization'][content['engineering-skill']].map(
                (x) => { return { value: x, label: _this.props.translate(`engineering-specialization.${content['engineering-skill']}.${x}`) } }
            );
        }

      if (i > 0) {
          contents.push(<div key={'separator-' + keySuffix} className="separator">
              <div className="delete-part" onClick={_this.remove.bind(_this, 'engineering', i)} key={'engineering-remove-' + keySuffix} id={'engineering-remove-' + keySuffix}>
                  <i className="fas fa-trash"></i>
              </div>
          </div>);
      }


        contents.push(<div key={'engineering1-' + keySuffix} className={"inline"} style={{ width: 'calc(28% - 9px)' }}>
            <SelectLabeled
                label={{ title: _this.props.translate(`engineering-specialization.${content['engineering-skill']}.title`) }}
                value={engineeringSkill}
                onChange={handleFieldOnChangeFactory('engineering-skill')}
                options={engineeringSkillOptions}
            />
      </div>)

        if (engineeringSpecializationOptions && engineeringSpecializationOptions.length > 0) {
          contents.push(<div key={'engineering2-' + keySuffix} className={"inline"} style={{ width: 'calc(28% - 9px)', marginLeft: '12px' }}>
              <SelectLabeled
                  label={{ title: _this.props.translate(`engineering-specialization.${content['engineering-skill']}.title`) }}
                  value={engineeringSpecialization}
                  onChange={handleFieldOnChangeFactory('engineering-specialization')}
                  options={engineeringSpecializationOptions}
              />
        </div>)
      }
    })

    contents.push(<div key={'intervention-level-duplicate'} className="duplicate" onClick={_this.duplicate.bind(_this, 'engineering')}>
      <AddButton />
    </div>)
    
    return (
      <div className={"formulaire wide"}>
        <div className={"formulaire-field text"}>
          {contents}
        </div>
      </div>
    )
  }

  renderCreateTechnicalSkillsInput() {
    var options = []
    var arr = []
    var _this = this


    _.each(_this.props.list.technical['domain-speciality'], function (specialityArray, competence) {
      specialityArray.map(speciality => {
        var obj = {};
        _.each(_this.props.list.technical['domain-competence'], function (competenceArray) {
          if (competenceArray.find(item => item === competence)) {
            const competenceLabel = _this.props.translate(['domain-competence'] + "." + competence);
            const specialityLabel = _this.props.translate(["domain-speciality"] + "." + [competence] + "." + [speciality]);

            obj['domain-speciality'] = speciality;
            obj['domain-competence'] = competence
            obj['label'] = `${specialityLabel} > ${competenceLabel} `;
            return options.push(obj);
          }
        });
        return null;
      });
    });

    _.each(_this.props.list.technical['domain-specificity'], function (specificityArr, key) {
      specificityArr.map(specificityName => {
        var obj = {};
        var competenceName;
        _.each(_this.props.list.technical['domain-speciality'], function (specialityArray, specialitykey) {
          if (specialityArray.filter(item => item === key).length !== 0) {
            return competenceName = specialitykey;
          }
        })
        arr.push(specificityName)
        obj['domain-specificity'] = specificityName;
        obj['domain-speciality'] = key;
        obj['domain-experience'] = "";
        obj['domain-competence'] = competenceName;
        const competenceLabel = _this.props.translate(['domain-competence'] + "." + competenceName);
        const specialityLabel = _this.props.translate(['domain-speciality'] + "." + [competenceName] + "." + [key]);
        const specificityLabel = _this.props.translate(['domain-specificity'] + "." + [key] + "." + [specificityName]);
        obj['label'] = `${specificityLabel} > ${specialityLabel} > ${competenceLabel} `;
        // obj['label'] = `${specificityName} > ${key} > ${competenceName}`;
        return options.push(obj);
      });
    });

    return <SelectAddField
      type={"project"}
      noLabel={false}
      isRequired={true}
      id={this.props.match.params.id}
      placeholder={<ContainerTranslation id={['content'] + "." + ['placeholder'] + "." + ['search-skill']} />}
      section={'content.environnement-domain'}
      parent={'expertise'}
      options={options} />;
  
  }

  renderTechnicalSkills(expertise = [{}]) {
    let contents = []
    const _this = this

    _.each(expertise, function (content, i) {
        const keySuffix = i + Date.now()

        const handleFieldOnChangeFactory = _this.handleFieldsOnChangeFactory('expertise', i)

        let domainCompetence = {
            value: content['domain-competence'],
            label: _this.props.translate(`domain-competence.${content['domain-competence']}`)
        };
        let domainCompetenceOptions = _this.props.list.technical['domain-competence']['Energy'].concat(_this.props.list.technical['domain-competence']['Railway']).map(
            (x) => { return { value: x, label: _this.props.translate(`domain-competence.${x}`) } }
        );


        let domainSpeciality = { value: "", label: "" };
        let domainSpecialityOptions = [];

        let domainSpecificity = { value: "", label: "" };
        let domainSpecificityOptions = [];

        if (_this.props.list.technical['domain-speciality'][content['domain-competence']]) {
            domainSpeciality = {
                value: content['domain-speciality'],
                label: _this.props.translate(`domain-speciality.${content['domain-competence']}.${content['domain-speciality']}`)
            };
            domainSpecialityOptions = _this.props.list.technical['domain-speciality'][content['domain-competence']].map(
                (x) => { return { value: x, label: _this.props.translate(`domain-speciality.${content['domain-competence']}.${x}`) } }
            );
        }

        if (_this.props.list.technical['domain-specificity'][content['domain-speciality']]) {
            domainSpecificity = {
                value: content['domain-specificity'],
                label: _this.props.translate(`domain-specificity.${content['domain-speciality']}.${content['domain-specificity']}`)
            };
            domainSpecificityOptions = _this.props.list.technical['domain-specificity'][content['domain-speciality']].map(
                (x) => { return { value: x, label: _this.props.translate(`domain-specificity.${content['domain-speciality']}.${x}`) } }
            );
        }

      if (i > 0) {
          contents.push(<div key={'separator-' + keySuffix} className="separator">
              <div className="delete-part" onClick={_this.remove.bind(_this, 'expertise', i)} key={'expertise-remove-' + keySuffix} id={'expertise-remove-' + keySuffix}>
                  <i className="fas fa-trash" style={{ color: '#ffffff' }}></i>
              </div>
          </div>)
      }
        contents.push(<div key={'expertise1-' + keySuffix} className={"inline"} style={{ width: 'calc(33.33% - 10px)' }}>
            <SelectLabeled
                label={{ title: _this.props.translate("content.expertise.domain-competence.title") }}
                value={domainCompetence}
                onChange={handleFieldOnChangeFactory('domain-competence')}
                options={domainCompetenceOptions}
            />
      </div>)
        if (domainSpecialityOptions && domainSpecialityOptions.length > 0) {
          contents.push(<div key={'expertise2-' + keySuffix} className={"inline"} style={{ width: 'calc(33.33% - 10px)', marginLeft: '15px' }}>
              <SelectLabeled
                  label={{ title: _this.props.translate("content.expertise.domain-speciality.title") }}
                  value={domainSpeciality}
                  onChange={handleFieldOnChangeFactory('domain-speciality')}
                  options={domainSpecialityOptions}
              />
        </div>)
      }
        if (domainSpecificityOptions && domainSpecificityOptions.length > 0) {
          contents.push(<div key={'expertise3-' + keySuffix} className={"inline"} style={{ width: 'calc(33.33% - 10px)', marginLeft: '15px' }}>
              <SelectLabeled
                  label={{ title: _this.props.translate("content.expertise.domain-specificity.title") }}
                  value={domainSpecificity}
                  onChange={handleFieldOnChangeFactory('domain-specificity')}
                  options={domainSpecificityOptions}
              />
        </div>)
      }
    })
    contents.push(<div key={'expertise-duplicate'} className="duplicate" onClick={_this.duplicate.bind(_this, 'expertise')}>
      <AddButton />
    </div>)

    return (
      <div className={"formulaire wide"}>
        <div className={"formulaire-field text"}>
          {contents}
        </div>
      </div>
    )

  }

  renderContexts(contexts) {
    var contents = []
    var subcontents = []
    var _this = this

    _.each(this.props.content['environnement']['environnement-domain'], function (domain, i) {
      var keySuffix = Date.now()
      subcontents = []
      _.each(contexts[domain], function (context, j) {
        var classContext = ''
        if (_this.props.content['environnement']['environnement-context'].indexOf(context) !== -1) {
          classContext = ' selected'
        }
        subcontents.push(
          <div key={context + '-' + keySuffix + i + j} className={"tab" + classContext} onClick={_this.handleContextChange.bind(_this, { name: "environnement-context", value: context, parent: "environnement" }, true, false)}>
            <ContainerTranslation id={['context'] + "." + [context]} />
          </div>
        )
      })

      contents.push(
        <div key={domain + '-' + keySuffix + i}>
          <label className={"required"}>
            <ContainerTranslation id={['context-title'] + "." + [domain]} />
            <ContainerTranslation id={['content.environnement'] + "." + ['environnement-context'] + ".sub"} tag={"p"} />
          </label>
          <div className={"formulaire-field tabs"} style={{ marginBottom: '22px' }}>
            {subcontents}
          </div>
        </div>
      )

    })

    return (
      <div className={"formulaire-field tabs"} style={{ textAlign: 'center', marginTop: '22px' }}>
        {contents}
      </div>
    )
  }


  renderValidate(route) {

    if(!localStorage.user || !this.props.project.authorization.validate){
      return null;
    }

    if(this.props.project.progression!==100 || 
      this.props.project.validationInformation.validationStatus === "document_validation_status_validated" ||
      this.props.project.validationInformation.validationStatus === "document_validation_status_rejected"){
      return(
        <Button data-disabled onClick={(event) => event.preventDefault()}>
          {this.props.translate("validation.confirmation-button.validated")}   
        </Button>
      )
    }

    if(this.props.project.progression===100 && this.state.isValidatePopupOpen === false ){
      return <div className="btn-dashboard"> 
                <button className="primary-btn"   onClick={ () => {this.toggleValidatePopup()} } >   
                  {this.props.translate("validation.confirmation-button.validated")}    
                </button>    
              </div>
    }

    if(this.props.project.progression===100 && this.state.isValidatePopupOpen){
      return(
          <div className="full-screen">
              <div className="popup popup-small">
                  <div style={{ position: "absolute", top: -18, right: -18 }}>
                      <ActionIcon variant="filled" radius="xl" size="xl" color="red">
                          <IconSquareRoundedX onClick={() => this.toggleValidatePopup()} style={{ width: '70%', height: '70%' }} />
                      </ActionIcon>
                  </div>
                  <div>
                      <div className="popup-message">
                          {this.props.translate("validation.confirmation-warning.validated")}
                      </div>
                      <div className="btn-dashboard centered">
                          <button className="primary-btn" onClick={() => { this.handleDocumentValidation(); window.location.href = route; }} >
                              {this.props.translate("validation.confirmation-button.validated")}
                          </button>
                      </div>
                  </div>
              </div>
          </div>
      )
    }


  }


  renderReject(route) {
    
    if(!localStorage.user || !this.props.project.authorization.validate){
      return null;
    }

    if(this.props.project.progression !== 100 || 
      this.props.project.validationInformation.validationStatus !== "document_validation_status_submitted"){
      return(
        <Button  data-disabled onClick={(event) => event.preventDefault()}>
          {this.props.translate("validation.confirmation-button.rejected")}
        </Button>
      )
    }

    if(this.props.project.progression === 100 && this.state.isRejectPopupOpen === false ){
      return <div className="btn-dashboard"> 
                <button className="primary-btn"   onClick={ () => {this.toggleRejectPopup()} } >   
                  {this.props.translate("validation.confirmation-button.rejected")}    
                </button>    
              </div>
    }

    if(this.props.project.progression === 100 && this.state.isRejectPopupOpen){

      return(
          <div className="full-screen">
              <div className="popup popup-large">
                  <div style={{ position: "absolute", top: -18, right: -18 }}>
                      <ActionIcon variant="filled" radius="xl" size="xl" color="red">
                          <IconSquareRoundedX onClick={() => this.toggleRejectPopup()} style={{ width: '70%', height: '70%' }} />
                      </ActionIcon>
                  </div>
                  <div>
                      <div className="popup-message">
                          {this.props.translate("validation.confirmation-warning.rejected")}
                      </div>
                      <div className="margin">
                          <TextAreaLabeledStatic
                              onChange={(event) => {
                                  let { name, value } = event.target;
                                  this.rejectReason.current = value
                              }}
                              name={'rejectReason'}
                              value={this.rejectReason.current}
                              isRequired={false}
                              label={{ title: 'reject reason' }}
                              placeholder={""}
                              maxLength={1000}
                              height={'100px'}
                          />
                      </div>
                      <div className="btn-dashboard centered">
                          <button className="primary-btn" onClick={() => { this.handleDocumentReject(); }} >
                              {this.props.translate("validation.confirmation-button.rejected")}
                          </button>
                      </div>
                  </div>
              </div>
          </div>
      )
    }


  }


  renderSubmit(route) {

    if(!localStorage.user || !this.props.project.authorization.write || this.props.project.authorization.validate){
      return null;
    }

    if(this.props.project.progression !== 100 || this.props.project.validationInformation.validationStatus !== "document_validation_status_draft" ){
      return(
        <Button data-disabled onClick={(event) => event.preventDefault()}>
          {this.props.translate("validation.confirmation-button.submitted")}
        </Button>
      )
    }

    if(this.props.project.progression === 100 && this.state.isSubmitPopupOpen === false ){
      return <div className="btn-dashboard"> 
              <button className="primary-btn"   onClick={ () => {this.toggleSubmitPopup()} } >   
                {this.props.translate("validation.confirmation-button.submitted")}  
              </button>   
            </div>
    }

    if(this.props.project.progression === 100 && this.state.isSubmitPopupOpen){
        return (
            <div className="full-screen">
                <div className="popup popup-small">
                    <div style={{ position: "absolute", top: -18, right: -18 }}>
                        <ActionIcon variant="filled" radius="xl" size="xl" color="red">
                            <IconSquareRoundedX onClick={() => this.toggleSubmitPopup()} style={{ width: '70%', height: '70%' }} />
                        </ActionIcon>
                    </div>
                    <div>
                        <div className="popup-message">
                            {this.props.translate("validation.confirmation-warning.submitted")}
                        </div>
                        <div className="btn-dashboard centered">
                            <button className="primary-btn" onClick={() => { this.handleDocumentSubmit(); }} >
                                {this.props.translate("validation.confirmation-button.submitted")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
      )
    }


  }


  renderDraft() {

    if(!localStorage.user || !this.props.project.authorization.write){
      return null;
    }


    if(this.props.error === "only document set to draft can be edited"){
      return(
          <div className="full-screen">
              <div className="popup popup-small">
                  <div style={{ position: "absolute", top: -18, right: -18 }}>
                      <ActionIcon variant="filled" radius="xl" size="xl" color="red">
                          <IconSquareRoundedX onClick={() => this.props.resetError()} style={{ width: '70%', height: '70%' }} />
                      </ActionIcon>
                  </div>
                  <div>
                      <div className="popup-message">
                          {this.props.translate("validation.confirmation-warning.drafted")}
                      </div>
                      <div className="btn-dashboard centered">
                          <button className="primary-btn" onClick={() => { this.handleDocumentDraft(); }} >
                              {this.props.translate("validation.confirmation-button.drafted")}
                          </button>
                      </div>
                  </div>
              </div>
          </div>
      )
    }


  }



  render() {

    if (Object.keys(this.props.project).length === 0 || Object.keys(this.props.list).length === 0) {
      return null
    }

    const route = "/project/" + this.props.match.params.id;

    const name = <ContainerTranslation id={"Page." + ['ProjectForm'] + "." + ['Project-title']} />;
    const subname = <ContainerTranslation id={"Page." + ['ProjectForm'] + "." + ['Project-subName']} />;


    const receivedContexts = this.props.list.contexts;

    const managers = this.props.list.managers;
    const tools = this.props.list.tools;
    const clients_lvl_1 =  Object.keys(this.props.list.clients.options);
    const client_lvl_1 = this.props.project.content.client['level_1']['value'];

    const programs = this.props.list.programs

    const classRailway = this.props.content['environnement']['environnement-domain'].indexOf('Railway') !== -1  ?  " selected" : ""
    const classEnergy = this.props.content['environnement']['environnement-domain'].indexOf('Energy') !== -1  ?  " selected" : ""
 

      const filialeCountry = {
          value: this.props.project.content['information']['filiale-country'],
          label: this.props.translate(`countries.${this.props.project.content['information']['filiale-country']}`)
      };

      const filialeCountryOptions = this.props.list.countries.map((x)=>{
          return {
              value: x, label: this.props.translate(`countries.${x}`)
          }
      });

      let filialeCity = { value: "", label: "" };
      let filialeCityOptions = [];


      if (this.props.list.offices[this.props.project.content['information']['filiale-country']]) {
          filialeCity = {
              value: this.props.project.content['information']['office'],
              label: this.props.project.content['information']['office']
          };

          filialeCityOptions = this.props.list.offices[this.props.project.content['information']['filiale-country']].map((x) => {
              return {
                  value: x, label: x
              }
          });
      }

      const typology = {
          value: this.props.project.content['information']['typology'],
          label: this.props.translate(`typology.${this.props.project.content['information']['typology']}`)
      };

      const typologyOptions = this.props.list.typologies.map((x) => {
          return {
              value: x, label: this.props.translate(`typology.${x}`)
          }
      });

      const phase = {
          value: this.props.project.content['information']['phase'],
          label: this.props.translate(`phases.${this.props.project.content['information']['phase']}`)
      };

      const phaseOptions = this.props.list.phases.map((x) => {
          return {
              value: x, label: this.props.translate(`phases.${x}`)
          }
      });

      const client_lvl_2 = { value: this.props.project.content.client['level_2']['value'], label: this.props.project.content.client['level_2']['value'] };
      const clients_lvl_2 = Object.keys(_.get(this.props.list.clients, "options." + client_lvl_1 + ".options", {}))
          .map((x) => {
              return { value: x, label: x }
          });


      const client_lvl_3 = { value: this.props.project.content.client['level_3']['value'], label: this.props.project.content.client['level_3']['value'] };
      const clients_lvl_3 = Object.keys(_.get(this.props.list.clients, "options." + client_lvl_2 + ".options", {}))
          .map((x) => {
              return { value: x, label: x }
          });

      const client_lvl_4 = { value: this.props.project.content.client['level_4']['value'], label: this.props.project.content.client['level_4']['value'] };
      const clients_lvl_4 = Object.keys(_.get(this.props.list.clients, "options." + client_lvl_3 + ".options", {}))
          .map((x) => {
              return { value: x, label: x }
          });

    return (

      <div className="formulaires">
        {this.state.isPopupDraftOpen ? this.renderDraftPopup() : null}
        <div className="formulaires-header">
          <h2>{name}</h2>
          <p style={{ margin: 0, textAlign: 'center' }}>{subname}</p>
          <span className="link-back"><Link to={route}><i className="fas fa-arrow-left" style={{ color: "#E30119", marginRight: "10px" }}></i><ContainerTranslation id={"nav.Back"} /></Link></span>
        </div>

        {this.renderDraft()}
        {/*NEW FORM*/}

        {/*INFORMATIONS*/}
        <div className="formulaire-section">

          <div className="formulaire-header">
            <ContainerTranslation id={"content." + ['information'] + ".title"} tag="h2" />
            <p className="info">{"The field marked with"}<span>*</span> are required</p>
          </div>

          <div className={"formulaire wide"}>

              <div className={"button-bar y-spaced"}>
                <div>{this.props.translate("content.information.isIkosProject.title")}</div>
                <SliderCheckboxLabeled
                  label={this.props.project.content.information.isIkos === "true" ? this.props.translate("general.yes") : this.props.translate("general.no")}
                  onClick={this.handleClickSwitchFactory("information", "isIkos")}
                  checked={this.props.project.content.information.isIkos === "true" ? true : false}
                  onLabel={this.props.translate("general.yes")}
                  offLabel={this.props.translate("general.no")}
                />
              </div>
              <div className={"button-bar y-spaced"} >
                <div>{this.props.translate("content.information.isHSEProject.title")}</div>
                <SliderCheckboxLabeled
                  label={this.props.project.content.information.isHSE === "true" ? this.props.translate("general.yes") : this.props.translate("general.no")}
                  onClick={this.handleClickSwitchFactory("information", "isHSE")}
                  checked={this.props.project.content.information.isHSE === "true" ? true : false}
                  onLabel={this.props.translate("general.yes")}
                  offLabel={this.props.translate("general.no")}
                />
              </div>
              <div className={"button-bar y-spaced"}>
                <div>{this.props.translate("content.information.isRSEProject.title")}</div>
                <SliderCheckboxLabeled
                  label={this.props.project.content.information.isRSE === "true" ? this.props.translate("general.yes") : this.props.translate("general.no")}
                  onClick={this.handleClickSwitchFactory("information", "isRSE")}
                  checked={this.props.project.content.information.isRSE === "true" ? true : false}
                  onLabel={this.props.translate("general.yes")}
                  offLabel={this.props.translate("general.no")}
                />
              </div>
                    <div className={"formulaire-field select"}>
                        <SelectLabeled
                            label={{ title: this.props.translate("content.information-consultant.filiale-country.title") }}
                            value={filialeCountry}
                            onChange={this.handleFieldOnChangeFactory('information','filiale-country')}
                            options={filialeCountryOptions}
                        />
            </div>
            {this.props.content['information']['filiale-country'] ?
                        <div className={"formulaire-field select"}>
                            <SelectLabeled
                                label={{ title: this.props.translate("content.information-consultant.office.title") }}
                                value={filialeCity}
                                onChange={this.handleFieldOnChangeFactory('information', 'office')}
                                options={filialeCityOptions}
                            />
              </div>
              :
              null
            }
                    <div className={"formulaire-field select"}>
                        <SelectLabeled
                            label={{ title: this.props.translate("content.information.typology.title") }}
                            value={typology}
                            onChange={this.handleFieldOnChangeFactory('information', 'typology')}
                            options={typologyOptions}
                        />
            </div>
                    <div className={"formulaire-field select"}>
                        <SelectLabeled
                            label={{ title: this.props.translate("content.information.phase.title") }}
                            value={phase}
                            onChange={this.handleFieldOnChangeFactory('information', 'phase')}
                            options={phaseOptions}
                        />
            </div>

            <div className={"formulaire-field select"}>
              <CreatableSelectLabeled
                label={{title:this.props.translate('content.information.manager.title')}}
                onChange={this.handleInputChangeFactoryNew('information','manager')}
                value={[{value:this.props.project.content['information']['manager'],label:this.props.project.content['information']['manager']}]}
                options={managers.map((ele)=>{return {value:ele,label:ele}})}
                isRequired={true}
              />
            </div>
            <div className={"formulaire-field text"}>
              <InputText
                onBlur={this.handleBlurFactory('information')}
                value={this.props.project.content['information']['name']}
                name={'name'}
                isRequired={true}
                label={{title : this.props.translate("content.information.name.title"), subtitle:this.props.translate("content.information.name.sub")}}
              />
            </div>
            <div className={"formulaire-field select"}>
              <CreatableSelectLabeled
                label={{title:this.props.translate('content.information.program.title')}}
                onChange={this.handleInputChangeFactoryNew('information','program')}
                value={[{value:this.props.project.content['information']['program'],label:this.props.project.content['information']['program']}]}
                options={programs.map((ele)=>{return {value:ele,label:ele}})}
              />
            </div>
            {this.props.content['information']['program'] ?
              <div className={"formulaire-field select"}>
                <CreatableSelectLabeled
                  label={{title:this.props.translate('content.information.subprogram.title')}}
                  onChange={this.handleInputChangeFactoryNew('information','subprogram')}
                  value={[{value:this.props.project.content['information']['subprogram'],label:this.props.project.content['information']['subprogram']}]}
                  options={[]}
                />
              </div>
              :
              null
            }
            <div className={"formulaire-field text"}>
              <div className={"inline"}>
                <InputDate
                  locale={this.props.translate('content.localisation')}
                  onChange={this.handleDateChangeFactory('start-date','information',null)}
                  value={this.string2Date(this.props.project.content['information']['start-date'])}
                  isRequired={false}
                  label={this.props.translate("content." + ['information'] + "." + ['start-date'] + ".title")}
                />
              </div>
              <div className={"inline"} style={{ marginLeft: '20px' }}>
                <InputDate
                  locale={this.props.translate('content.localisation')}
                  onChange={this.handleDateChangeFactory('end-date','information',null)}
                  value={this.string2Date(this.props.project.content['information']['end-date'])}
                  isRequired={false}
                  label={this.props.translate("content." + ['information'] + "." + ['end-date'] + ".title")}
                />
              </div>
            </div>
          </div>

        </div>

        {/*CLIENT*/}
        <div className="formulaire-section">

          <div className="formulaire-header">
            <ContainerTranslation id={"content." + ['client'] + ".title"} tag="h2" />
            <p className="info">{"The field marked with"}<span>*</span> are required</p>
          </div>

          <div className={"formulaire wide"}>
            <div className={"formulaire-field select"}>
              <CreatableSelectLabeled
                label={{title:this.props.translate('content.client.level_1.title')}}
                onChange={this.handleInputChangeFactoryNew('client','level_1.value')}
                value={[{value:client_lvl_1,label:client_lvl_1}]}
                options={clients_lvl_1.map((c)=>{return {value:c,label:c}})}
                isRequired={true}
              />
            </div>
            {clients_lvl_2.length > 0 ?
                        <div className={"formulaire-field select"}>
                            <SelectLabeled
                                label={{ title: this.props.translate("content.client.level_2.title") }}
                                value={client_lvl_2}
                                onChange={this.handleFieldOnChangeFactory('client', 'level_2.value')}
                                options={clients_lvl_2}
                            />
              </div>
              :
              null
            }
            {clients_lvl_3.length > 0 ?
                        <div className={"formulaire-field select"}>
                            <SelectLabeled
                                label={{ title: this.props.translate("content.client.level_3.title") }}
                                value={client_lvl_3}
                                onChange={this.handleFieldOnChangeFactory('client', 'level_3.value')}
                                options={clients_lvl_3}
                            />
              </div>
              :
              null
            }
            {clients_lvl_4.length > 0 ?
                        <div className={"formulaire-field select"}>
                            <SelectLabeled
                                label={{ title: this.props.translate("content.client.level_4.title") }}
                                value={client_lvl_4}
                                onChange={this.handleFieldOnChangeFactory('client', 'level_4.value')}
                                options={clients_lvl_4}
                            />
              </div>
              :
              null
            }
            <div className={"formulaire-field text"}>
              <InputText
                onBlur={this.handleBlurFactory('client')}
                value={this.props.project.content['client']['supervisor']}
                name={'supervisor'}
                isRequired={false}
                label={{title : this.props.translate("content.client.supervisor.title"), subtitle:this.props.translate("content.client.supervisor.sub")}}
              />
            </div>
            <div className={"formulaire-field text"}>
              <InputText
                onBlur={this.handleBlurFactory('client')}
                value={this.props.project.content['client']['localisation-client-country']}
                name={'localisation-client-country'}
                isRequired={false}
                label={{title : this.props.translate("content.client.localisation-client-country.title"), subtitle:this.props.translate("content.client.localisation-client-country.sub")}}
              />
            </div>
            {this.props.project.content['client']['localisation-client-country'] ?
              <div className={"formulaire-field text"}>
              <InputText
                onBlur={this.handleBlurFactory('client')}
                value={this.props.project.content['client']['localisation-client-cp']}
                name={'localisation-client-cp'}
                isRequired={false}
                label={{title : this.props.translate("content.client.localisation-client-cp.title"), subtitle:this.props.translate("content.client.localisation-client-cp.sub")}}
              />
              </div>
              :
              null
            }
            <div className={"formulaire-field text"}>
              <InputText
                onBlur={this.handleBlurFactory('client')}
                value={this.props.project.content['client']['localisation-deploiement-country']}
                name={'localisation-deploiement-country'}
                isRequired={false}
                label={{title : this.props.translate("content.client.localisation-deploiement-country.title"), subtitle:this.props.translate("content.client.localisation-deploiement-country.sub")}}
              />
            </div>
            {this.props.project.content['client']['localisation-deploiement-country'] ?
              <div className={"formulaire-field text"}>
                <InputText
                  onBlur={this.handleBlurFactory('client')}
                  value={this.props.project.content['client']['localisation-deploiement-cp']}
                  name={'localisation-deploiement-cp'}
                  isRequired={false}
                  label={{title : this.props.translate("content.client.localisation-deploiement-cp.title"), subtitle:this.props.translate("content.client.localisation-deploiement-cp.sub")}}
                />
              </div>
              :
              null
            }
          </div>

        </div>

        {/*OPERATIONAL SKILLS*/}
        <div className="formulaire-section">

          <div className="formulaire-header">
            <ContainerTranslation id={"content." + ['intervention-level'] + ".title"} tag="h2" />
            <div style={{ width: 350 }}>
              {this.renderCreateOperationalSkillsInput()}
            </div>
          </div>
          {this.renderOperationalSkills(this.props.project.content['intervention-level'])}

        </div>


        {/*INGENERING SKILLS*/}
        <div className="formulaire-section">
          <div className="formulaire-header">
            <ContainerTranslation id={"content." + ['engineering'] + ".title"} tag="h2" />
            <div style={{ width: 350 }}>
              {this.renderCreateEngineeringSkillsInput()}
            </div>
          </div>
          {this.renderEngineeringSkills(this.props.project.content['engineering'])}
        </div>

        {/*ENVIRONNEMENT*/}
        <div className="formulaire-section">

          <div className="formulaire-header">
            <ContainerTranslation id={"content." + ['environnement'] + ".title"} tag="h2" />
            <div className={"formulaire-field tabs"}>
              <div className={"formulaire-field tab" + classEnergy} onClick={this.handleEnvironnementChange.bind(this, { name: "environnement-domain", value: "Energy", parent: "environnement" }, true, false)}>
                <i className="fas fa-plug" style={{ marginRight: "10px" }}></i><ContainerTranslation id={"secteur.Energy"} />
              </div>
              <div className={"formulaire-field tab" + classRailway} onClick={this.handleEnvironnementChange.bind(this, { name: "environnement-domain", value: "Railway", parent: "environnement" }, true, false)}>
                <i className="fas fa-train" style={{ marginRight: "10px" }}></i><ContainerTranslation id={"secteur.Railway"} />
              </div>
            </div>
          </div>

          {this.props.content['environnement']['environnement-domain'].length ?
            <div className={"formulaire wide"}>
              {this.renderContexts(receivedContexts)}
            </div>
            :
            null
          }
        </div>

        {/*TECHNICAL SKILLS */}
        <div className="formulaire-section">
          <div className="formulaire-header">
            <ContainerTranslation id={"content." + ['expertise'] + ".title"} tag="h2" />
            <div style={{ width: 350 }}>
              {this.renderCreateTechnicalSkillsInput()}
            </div>
          </div>
          {this.renderTechnicalSkills(this.props.project.content.expertise)}
        </div>

        {/*TOOLS*/}
        <div className="formulaire-section">

          <div className="formulaire-header">
            <ContainerTranslation id={"content." + ['tools'] + ".title"} tag="h2" />
          </div>

          <div className={"formulaire wide"}>
            <div className={"formulaire-field select"}>
              <CreatableSelectLabeled
                label={{title:this.props.translate('content.tools.tool.title')}}
                onChange={this.handleInputChangeFactoryNew('tools')}
                value={this.props.project.content['tools'] ? this.props.project.content['tools'].map((ele)=>{return {value:ele,label:ele}}) : []}
                options={tools.map((c)=>{return {value:c,label:c}})}
                isRequired={true}
                multi={true}
              />
            </div>
          </div>

        </div>

        {/*NOTES*/}
        <div className="formulaire-section">

          <div className="formulaire-header">
            <ContainerTranslation id={"content." + ['notes'] + ".title"} tag="h2" />
            <p className="info">{"The field marked with"}<span>*</span> are required</p>
          </div>

          <div className={"formulaire wide"}>
            <div className={"formulaire-field select"}>
              <CreatableSelectLabeled
                            label={{ title: this.props.translate('content.notes.keywords.title'), subtitle: this.props.translate('content.notes.keywords.sub') }}
                onChange={this.handleInputChangeFactoryNew('notes','keywords')}
                value={this.props.project.content['notes']['keywords'] ? this.props.project.content['notes']['keywords'].map((ele)=>{return {value:ele,label:ele}}) : []}
                options={[]}
                isRequired={true}
                multi={true}
              />
            </div>

            <div className={"formulaire-field textarea"}>
              <TextAreaLabeled
                onBlur={this.handleBlurFactory('notes')}
                name={'objectives'}
                value={this.props.project.content['notes']['objectives']}
                isRequired={true}
                label={{title :this.props.translate("content.notes.objectives.title")}}
                placeholder={exampleContext}
                maxLength={500}
                height={'160px'}
              />
            </div>

            <div className={"formulaire-field textarea"}>
              <TextAreaLabeled
                onBlur={this.handleBlurFactory('notes')}
                name={'context'}
                value={this.props.project.content['notes']['context']}
                isRequired={true}
                label={{title :this.props.translate("content.notes.process.title")}}
                placeholder={exampleObjectives}
                maxLength={740}
                height={'180px'}
              />
            </div>

            <div className={"formulaire-field textarea"}>
              <TextAreaLabeled
                onBlur={this.handleBlurFactory('notes')}
                name={'activity'}
                value={this.props.project.content['notes']['activity']}
                isRequired={true}
                label={{title :this.props.translate("content.notes.result.title")}}
                placeholder={exampleActivity}
                maxLength={2600}
                height={'560px'}
              />
            </div>
          </div>

        </div>

        {/*END NEW FORM*/}

        <div className="btn-dashboard">
          <p>{this.props.project.progression ? this.props.project.progression : 0}<ContainerTranslation id={"nav." + ['completed']} /></p>

          <div>
            <ExtractorPowerPoint className="primary-btn" style={{width:"180px",height:"48px"}} title={"Verify project overview"} projects={this.props.project} translate={this.props.translate} />
          </div>
          <div>
            <Link to={route}><button className="primary-btn"><ContainerTranslation id={"nav." + ['Back to the dashboard']} /></button></Link>
          </div>
          <div className="renderValidate" style={{paddingBlock:"10px"}}  >
                {this.renderValidate(route)}
            </div>
            <div className="renderValidate" style={{paddingBlock:"10px"}}  >
                {this.renderReject(route)}
            </div>
            <div className="renderValidate" >
                {this.renderSubmit(route)}
            </div>
        </div>

        <div className="scrollTop" onClick={this.scrollTop.bind(this)}>
          <i className="fas fa-arrow-up" style={{ color: "#E30119" }}></i>
        </div>
      </div>
    )
    
  }
}

const mapStateToProps = state => ({
  content: state.project.project.content,
  project: state.project.project,
  list: state.project.list,
  message: state.project.message,
  error:state.project.error
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchProject, 
  updateFieldProject, 
  addFieldProject, 
  removeFieldProject, 
  getAutocompleteList, 
  validate,  
  submit,
  draft,
  reject,
  resetError
}, dispatch); 

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withLocalize(FormContainer)));